import type { UseControllerProps } from 'react-hook-form';

/**
 * Transforms a label to include an asterisk if the Controller contains the prop `required`. Required can exist in 3 states, depending on implementation.
 * @controller The required rule in React Hook Form's controller can be a boolean, string, or an object of shape { value: boolean; message: string }. To ensure consistent behavior and accurate label rendering (e.g., appending an asterisk), we use a switch statement to handle each type explicitly.
 * @returns Return the label with/without an asterisk to indicate if it is required
 */
export const getComputedLabel = (label: string, controller: UseControllerProps<any>): string => {
  const requiredRule = controller.rules?.required;

  switch (typeof requiredRule) {
    case 'boolean':
      return requiredRule ? `${label} *` : label;
    case 'string':
      return `${label} *`;
    case 'object':
      if (requiredRule && 'value' in requiredRule) {
        return requiredRule.value ? `${label} *` : label;
      }
      return label;

    default:
      return label;
  }
};
